var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEligibilityExpired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.777344,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FFFAEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18047_301943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99989 8.77793V10.7779M9.99989 12.7779H10.0049M9.14489 6.20793L4.90989 13.2779C4.82257 13.4291 4.77637 13.6006 4.77588 13.7752C4.77539 13.9498 4.82063 14.1215 4.9071 14.2732C4.99357 14.4249 5.11825 14.5513 5.26874 14.6399C5.41923 14.7284 5.59029 14.776 5.76489 14.7779H14.2349C14.4095 14.776 14.5805 14.7284 14.731 14.6399C14.8815 14.5513 15.0062 14.4249 15.0927 14.2732C15.1791 14.1215 15.2244 13.9498 15.2239 13.7752C15.2234 13.6006 15.1772 13.4291 15.0899 13.2779L10.8549 6.20793C10.7658 6.06099 10.6402 5.93949 10.4905 5.85518C10.3407 5.77086 10.1718 5.72656 9.99989 5.72656C9.82802 5.72656 9.65905 5.77086 9.50929 5.85518C9.35953 5.93949 9.23402 6.06099 9.14489 6.20793Z",
    stroke: "#F79009",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18047_301943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4.77734)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibilityExpired);
export default __webpack_public_path__ + "static/media/eligibilityExpired.f9b3a97a85a0cccc701641423ef0bb87.svg";
export { ForwardRef as ReactComponent };